import isInterfaceHidden from './is-interface-hidden';

const getHideInterfaceClassName = state =>
  isInterfaceHidden(state) ? 'hide-interface' : '';

export default getHideInterfaceClassName;
